export {default as editParkingType} from './edit'